<template>
  <section ref="about" class="about mt-8">
    <div class="container" data-aos="fade-up">
      <div class="section-header">
        <h2>Privacy Policy</h2>
      </div>
      <p>At <strong>myvoco.vote</strong>, your privacy is critically important to us. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our services.</p>
<h2>1. Information We Collect</h2>
  <ul>
    <li><strong>Account Data:</strong> Name, email address, region, and preferences.</li>
    <li><strong>Activity Data:</strong> Questions asked, votes cast, and poll interactions.</li>
    <li><strong>Device Data:</strong> IP address, device/browser type, and access times.</li>
  </ul>

  <h2>2. Use of Information</h2>
  <ul>
    <li>To provide personalized voting and polling experiences.</li>
    <li>To manage user accounts and deliver customer support.</li>
    <li>To improve platform functionality and user satisfaction.</li>
    <li>To communicate important updates, news, and promotions.</li>
  </ul>

  <h2>3. Election Data Security</h2>
  <p>When you participate in elections on myvoco.vote, your data is protected using advanced <strong>blockchain-based security architecture</strong> that ensures:</p>
  <ul>
    <li><strong>End-to-End Encryption:</strong> All voting data is encrypted and cannot be altered.</li>
    <li><strong>Immutable Ledger:</strong> Each vote is recorded permanently and transparently on a blockchain ledger.</li>
    <li><strong>Anonymity:</strong> Your identity remains private. Votes are not tied to your personal data.</li>
  </ul>
  <p>This ensures elections are fair, secure, and trustworthy.</p>

  <h2>4. Sharing and Disclosure</h2>
  <p>We do not sell or rent your personal data. Information may be shared only with trusted service providers who support our operations or when required by law enforcement or legal obligations.</p>

  <h2>5. Accuracy of Information</h2>
  <p>You are responsible for ensuring that all personal data you provide is accurate and up-to-date. If your information changes, please update it within your profile or notify us so we can correct it.</p>

  <h2>6. Your Rights</h2>
  <p>You may request access to, update, or delete your personal information at any time by contacting our support team. We will respond in accordance with applicable privacy laws.</p>

  <h2>7. Data Retention</h2>
  <p>We retain your personal data for as long as needed to fulfill the purposes described in this policy or as required by law.</p>

  <h2>8. Children’s Privacy</h2>
  <p>myvoco.vote is not intended for individuals under 13 years of age. We do not knowingly collect personal information from children without verified parental consent.</p>

  <h2>9. Policy Updates</h2>
  <p>We may revise this Privacy Policy from time to time. The most current version will be posted on our website with an updated effective date at the top.</p>

  <h2>10. Contact Us</h2>
  <p>If you have any questions about this policy or your personal data, please contact us at <a href="mailto:hello@damnnint.com">hello@damnnint.com</a>.</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Privacy",
};
</script>

<style scoped>
h2 {
  color: #333;
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
